/**
 * Check if fiat currency should be displayed right-to-left
 */
export function checkIfFiatCurrencyIsRTL({
  fiatCode,
}: {
  fiatCode?: string
}): boolean {
  if (!fiatCode) return false

  // List of RTL currencies (currencies used in RTL countries)
  const rtlCurrencies = [
    'AED', // UAE Dirham
    'BHD', // Bahraini Dinar
    'DZD', // Algerian Dinar
    'EGP', // Egyptian Pound
    'IQD', // Iraqi Dinar
    'JOD', // Jordanian Dinar
    'KWD', // Kuwaiti Dinar
    'LBP', // Lebanese Pound
    'LYD', // Libyan Dinar
    'MAD', // Moroccan Dirham
    'OMR', // Omani Rial
    'QAR', // Qatari Riyal
    'SAR', // Saudi Riyal
    'SYP', // Syrian Pound
    'TND', // Tunisian Dinar
    'YER', // Yemeni Rial
  ]

  return rtlCurrencies.includes(fiatCode)
}
